import React, { useState } from 'react';
import { PlusIcon, MinusIcon } from 'lucide-react';
import { faqs } from '../data/faqs';
export function Faq() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="w-full bg-white py-20" aria-labelledby="faq-title" data-id="element-53" data-mp="1laza77h5z5cb">
      <div className="mx-auto max-w-3xl px-5 sm:px-8" data-id="element-54" data-mp="1gcpb4lsbjklf">
        <h2 id="faq-title" className="font-display text-3xl font-black tracking-tight text-court-950 sm:text-4xl" data-id="element-55" data-mp="1ge8vool0cht0">
          Frequently Asked Questions
        </h2>

        <div className="mt-10 divide-y divide-court-950/10 border-y border-court-950/10" data-id="element-56" data-mp="291wbzrf8wm9u">
          {faqs.map((faq, index) => {
          const isOpen = openIndex === index;
          return <div key={faq.question} data-id="element-57" data-mp="1z2nj71w49dp2" data-mpi={index}>
                <h3 data-id="element-58" data-mp="sn3h0cqszvka">
                  <button type="button" onClick={() => setOpenIndex(isOpen ? null : index)} aria-expanded={isOpen} aria-controls={`faq-panel-${index}`} className="flex w-full items-start justify-between gap-6 py-5 text-left transition-colors duration-150 ease-smooth hover:text-court-700 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-court-950" data-id="element-59" data-mp="snmpl2ukd7ln">
                    <span className="font-display text-base font-bold leading-snug tracking-tight text-court-950 sm:text-lg" data-id="element-60" data-mp="kil4q7k01ge4">
                      {faq.question}
                    </span>
                    {isOpen ? <MinusIcon className="mt-1 h-5 w-5 shrink-0 text-court-950" aria-hidden="true" data-id="element-61" data-mp="bj84m5hrm462" /> : <PlusIcon className="mt-1 h-5 w-5 shrink-0 text-court-600" aria-hidden="true" data-id="element-62" data-mp="1tetf5ljbr2c" />}
                  </button>
                </h3>
                {isOpen && <p id={`faq-panel-${index}`} className="pb-6 pr-10 text-sm leading-relaxed text-court-700" data-id="element-63" data-mp="1ugkvi5fo9yja">
                    {faq.answer}
                  </p>}
              </div>;
        })}
        </div>
      </div>
    </section>;
}